import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { SubstationCrudCreate } from '../models/substation.model';

@Injectable({
  providedIn: 'root',
})
export class SubstationService {
  private pathApi = this.config.setting['pathApi'] + 'substation/';

  constructor(
    private http: HttpClient,
    private config: AppConfig,
  ) {}

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      observe: 'response',
    });
  }

  save(ss: SubstationCrudCreate): Observable<any> {
    return this.http.post(`${this.pathApi}save`, ss, { observe: 'response' });
  }

  delete(id: number, record: string = ''): Observable<any> {
    const query = record ? `?record=${encodeURIComponent(record)}` : '';
    return this.http.delete(`${this.pathApi}delete/${id}${query}`, {
      observe: 'response',
    });
  }

  getAllForSelect(utilityId: number | null = null): Observable<any> {
    if (utilityId) {
      return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, {
        observe: 'response',
      });
    } else {
      return this.http.get(`${this.pathApi}getAllForSelect`, {
        observe: 'response',
      });
    }
  }
  getF33sBySSId(id: number): Observable<any> {
    return this.http.get(`${this.pathApi}getF33sBySSid/${id}`, {
      observe: 'response',
    });
  }

  downloadFile(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, dataIn);
  }

  uploadFile(obj: any, utilityId: number): Observable<any> {
    var api = this.config.setting['pathApi'] + 'cim/CimSubstation/';
    return this.http.post(`${api}uploadFile?utilityId=${utilityId}`, obj);
  }

  generateTemplate(utilityId: number): Observable<any> {
    var api = this.config.setting['pathApi'] + 'cim/CimSubstation/';
    return this.http.get(
      `${api}generateTemplate?utilityId=${utilityId}`,
    );
  }

  generateAuthorizeMeteringTemplate(utilityId: number): Observable<any> {
    var api = this.config.setting['pathApi'] + 'cim/CimSubstation/';
    return this.http.get(
      `${api}generateAuthorizeMeteringTemplate?utilityId=${utilityId}`,
    );
  }

  uploadAuthorizeMetering(obj: any): Observable<any> {
    var api = this.config.setting['pathApi'] + 'cim/CimSubstation/';
    return this.http.post(`${api}uploadAuthorizeMetering`, obj);
  }
}
